const setMainListItems = (id, text, to, check) => ({ id, text, to, check });
export const mainListItems = [
  setMainListItems(1, "Campuses", "campuses", "campuses"),
  setMainListItems(2, "User Roles", "user", "user"),
  setMainListItems(3, "Policies", "policies", "policies"),
  setMainListItems(4, "Release", "release", "release"),
];